import { ActionEvents } from '@griply/types';
import { useCallback, useEffect, useState } from 'react';
import { useTrackEvents } from 'shared/hooks/use-track-events';

export const useNotificationPermission = (): [
  permission: PermissionState,
  requestPermission: () => Promise<NotificationPermission | undefined>,
] => {
  const [permission, setPermission] = useState<PermissionState>('prompt');
  const track = useTrackEvents();

  const requestPermission = useCallback(async () => {
    track(ActionEvents.InitialPushNotificationsQuestion, undefined);
    if (!('Notification' in window)) {
      return;
    }

    return Notification.requestPermission();
  }, [track]);

  useEffect(() => {
    (async function () {
      const permission = await navigator?.permissions?.query({
        name: 'notifications',
      });

      if (!permission) {
        return;
      }

      setPermission(permission.state);
      permission.onchange = () => {
        setPermission(permission.state);
      };
    })();
  }, []);

  return [permission, requestPermission];
};
